import $ from 'jquery';

const ValueSlider = function () {
  const $el = $('.js-valueSlider');
  $el.hide();
  $(window).on('load', function () {
    $el.show();

    class Slider {
      constructor($el) {
        this.$wrap = $el;
        this.$slider = this.$wrap.find('.js-valueSlider');
        this.$nav = this.$wrap.find('.js-valueSliderNav');
        this.$row = this.$nav.children('li');
        this.handler();
      }
      // ハンドラー
      handler() {
        this.getSlideIndex();
        this.setSlick();
        this.clickNav();
        this.setPosition();
      }
      // ナビゲーションに矢印付けるためのクラス付与
      setNav(i) {
        this.$nav.children('li').removeClass('is-current');
        this.$nav.children(`li:nth-child(${i})`).addClass('is-current');
      }
      // ナビゲーションクリック時のハンドラ
      clickNav() {
        const self = this;
        this.$row.on('click', function () {
          self.gotoSlide(self.$row.index($(this)));
        })
      }
      // ナビゲーションのインデックスに応じてスライド
      gotoSlide(i) {
        this.$slider.slick('slickGoTo', i);
      }
      // 現在のインデックスを取得
      getSlideIndex() {
        const self = this;
        this.$slider.on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
          self.setNav((nextSlide ? nextSlide : 0) + 1);
        });
      }
      // Slick
      setSlick() {
        this.$slider.slick({
          autoplay: true,
          arrows: false,
          dots: true,
          variableWidth: false,
          pauseOnFocus: false,
          pauseOnHover: false,
          lazyLoad: 'progressive',
        });
      }
      //タブでdisplay:noneが崩れる対策用
      setPosition() {
        const self = this
        if($('#js-tabs')){
          $('.c-tab__btn').on('click',function(){
            self.$slider.slick('setPosition')
          })
        }
      }
    }
    // 全てのセクションをインスタンス化
    $('.js-valueSliderWrap').each((i, e) => {
      new Slider($(e));
    });

  });
}

export default ValueSlider;


// WEBPACK FOOTER //
// ./src/recruit/js/valueSlider.js